// extracted by mini-css-extract-plugin
module.exports = {"label":"sCIx5x26MTFciac1TQWaB"};